import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReportUserDataTypes } from '@xbs/xbs-enums';

import {
  GenerateReportsForEntityIds,
  EntityForReportGenerator,
  GenerateReportPayload,
  ReportGeneratorTemplatesResponse,
  GeneratePlanningReportPayload,
  OrgChartSummaryPayload
} from '../../shared/models';
import { ObjectResponse } from '../interfaces';
import { AppConfig } from './app-config';
import { MasterFileGenerateReportPayload } from '../models/master-file-generate-report-payload';

@Injectable()
export class TpReportGeneratorService {

  constructor(private _http: HttpClient, private _config: AppConfig) { }

  public generateReportsForEntityIds(entities: EntityForReportGenerator[]):
    Observable<ObjectResponse<GenerateReportsForEntityIds>> {
    const payload = {
      entities,
    };

    return this._http.post<ObjectResponse<GenerateReportsForEntityIds>>(
      this.getTPReportGeneratorGenerateReportsUrl(),
      payload
    );
  }

  public generateReport(payload: GenerateReportPayload):
    Observable<ObjectResponse<any>> {
    return this._http.post<ObjectResponse<any>>(
      this.getTPReportGeneratorGenerateReportsUrl(),
      payload
    );
  }

  public generateMasterFileReport(payload: MasterFileGenerateReportPayload):
  Observable<ObjectResponse<GenerateReportsForEntityIds>> {
    return this._http.post<ObjectResponse<GenerateReportsForEntityIds>>(
      this.getTPReportGeneratorGenerateReportsUrl(),
      payload
    );
  }

  public generatePlanningReport(payload: GeneratePlanningReportPayload): Observable<ObjectResponse<GenerateReportsForEntityIds>> {
    return this._http.post<ObjectResponse<GenerateReportsForEntityIds>>(this.getTPReportGeneratorGenerateReportsUrl(), payload);
  }

  public getTemplatesForEntity(entityId: number): Observable<ObjectResponse<ReportGeneratorTemplatesResponse>> {
    return this._http.get<ObjectResponse<ReportGeneratorTemplatesResponse>>(
      this.getTPReportGeneratorTemplatesUrl(entityId)
    );
  }

  public saveOrgChartSummary(orgChartSummary: string, reportId: number, containerId: number): Observable<string> {
    return this._http.post<string>(`${this.getApiUrl()}container/${containerId}/report/${reportId}/user-input-data`, { userInputData: orgChartSummary, inputDataTypeId: ReportUserDataTypes.ByName.OrgChartSummary.Id });
  }

  public getOrgChartSummary(reportId: number, containerId: number): Observable<ObjectResponse<OrgChartSummaryPayload>> {
    return this._http.get<ObjectResponse<OrgChartSummaryPayload>>(`${this.getApiUrl()}container/${containerId}/report/${reportId}/user-input-data/${ReportUserDataTypes.ByName.OrgChartSummary.Id}`);
  }

  protected getTPReportGeneratorTemplatesUrl(entityId: number): string {
    return `${this.getApiUrl()}entity/${entityId}/templates`;
  }

  protected getTPReportGeneratorGenerateReportsUrl(): string {
    return `${this.getApiUrl()}generate-reports`;
  }

  private getApiUrl(): string {
    return `${this._config.getTpReportGeneratorApiUrl()}/v1/`;
  }
}
